<template>
  <div class="itinerary-review-step">
    <h3 class="itinerary-review-step__title">Dados do roteiro</h3>
    <p v-if="!readonly" class="itinerary-review-step__hint">
      Revise as informações antes de salvar o roteiro
    </p>

    <div class="itinerary-review-step__row">
      <div class="itinerary-review-step__row-head">
        <span class="itinerary-review-step__label">Nome</span>
        <a-tooltip v-if="!readonly" title="Editar dados">
          <button
            type="button"
            class="itinerary-review-step__icon-btn"
            @click="$emit('edit-step', 0)"
          >
            <a-icon type="form" />
          </button>
        </a-tooltip>
      </div>
      <div class="itinerary-review-step__value">{{ codigo }} {{ nome }}</div>
    </div>

    <div class="itinerary-review-step__row">
      <span class="itinerary-review-step__label">Paradas</span>
      <div class="itinerary-review-step__value">
        {{ paradas.length }} {{ paradas.length === 1 ? "parada" : "paradas" }}
      </div>
    </div>

    <h4 class="itinerary-review-step__section">
      Todas as paradas deste roteiro
    </h4>

    <div class="itinerary-review-step__list">
      <div
        v-for="parada in paradas"
        :key="parada.id"
        class="itinerary-review-step__card"
      >
        <span class="itinerary-review-step__card-icon">
          <a-icon type="environment" />
        </span>

        <div class="itinerary-review-step__card-text">
          <span class="itinerary-review-step__card-name">{{
            parada.nome
          }}</span>
          <span class="itinerary-review-step__card-subtitle">
            <span class="itinerary-review-step__subtitle-text">{{
              parada.cnpj
            }}</span>
            <span class="itinerary-review-step__dot" />
            <span class="itinerary-review-step__subtitle-text">
              {{ parada.cidade }} - {{ parada.uf }}
            </span>
          </span>
        </div>

        <div v-if="!readonly" class="itinerary-review-step__card-actions">
          <a-tooltip title="Editar dados">
            <button
              type="button"
              class="itinerary-review-step__icon-btn"
              @click="$emit('edit-step', 1)"
            >
              <a-icon type="form" />
            </button>
          </a-tooltip>
          <a-tooltip title="Remover parada">
            <button
              type="button"
              class="itinerary-review-step__icon-btn itinerary-review-step__icon-btn--danger"
              @click="$emit('remove-stop', parada.id)"
            >
              <a-icon type="delete" />
            </button>
          </a-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItineraryReviewStep",
  props: {
    codigo: { type: String, default: "" },
    nome: { type: String, default: "" },
    paradas: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.itinerary-review-step {
  &__title {
    font-size: 16px;
    font-weight: 600;
    color: @color-text-dark;
    margin: 0 0 4px;
  }

  &__hint {
    font-size: 13px;
    color: @color-text-medium;
    margin: 0 0 20px;
  }

  &__row {
    margin-bottom: 16px;
  }

  &__row-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__label {
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.45);
  }

  &__value {
    margin-top: 2px;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.88);
  }

  &__section {
    font-size: 14px;
    font-weight: 600;
    margin: 24px 0 12px;
    color: @color-text-dark;
  }

  &__card {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 8px;
    margin-bottom: 8px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 8px;
  }

  &__card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 20px;
    height: 20px;
    border-radius: 99px;
    background: rgba(0, 0, 0, 0.04);
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
  }

  &__card-text {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
  }

  &__card-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 600;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.88);
  }

  &__card-subtitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }

  &__subtitle-text {
    font-size: 12px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.45);
  }

  &__dot {
    flex: none;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.15);
  }

  &__card-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: none;
  }

  &__icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: transparent;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.88);
    }

    &--danger {
      color: #d9363e;

      &:hover {
        background: rgba(217, 54, 62, 0.08);
        color: #d9363e;
      }
    }
  }
}
</style>
